module.exports = __webpack_public_path__ + "img/nissanrelays.d94314a2.jpg";